import { render, staticRenderFns } from "./ShowBankAccountsPage.vue?vue&type=template&id=166f3496&"
import script from "./ShowBankAccountsPage.vue?vue&type=script&lang=js&"
export * from "./ShowBankAccountsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports